var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"app-logo-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }